// extracted by mini-css-extract-plugin
module.exports = {"PaginationWrapper":"styles_PaginationWrapper__3Agy-"};